/* =====================================================================
   CHLOROFRIENDS · Announcement Bar behavior
   - auto-rotates messages (fade), pauses on hover/focus
   - respects prefers-reduced-motion (no auto-rotation)
   - live countdown for [data-countdown="<ISO>"]
   - dismissible with localStorage expiry
   Works identically for the Liquid output and the HTML preview harness.
   ===================================================================== */
(function () {
  'use strict';

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function initBar(bar) {
    var key = bar.getAttribute('data-key') || 'cf_announce_dismissed';
    var dismissDays = parseInt(bar.getAttribute('data-dismiss-days') || '7', 10);

    /* ---- dismissal state ---- */
    try {
      var until = parseInt(window.localStorage.getItem(key) || '0', 10);
      if (until && Date.now() < until) { bar.hidden = true; return; }
    } catch (e) { /* storage blocked — show anyway */ }

    var closeBtn = bar.querySelector('.cf-announce__close');
    if (closeBtn) {
      closeBtn.addEventListener('click', function () {
        bar.hidden = true;
        try {
          window.localStorage.setItem(key, String(Date.now() + dismissDays * 864e5));
        } catch (e) { /* ignore */ }
      });
    }

    /* ---- live countdowns ---- */
    var counts = bar.querySelectorAll('[data-countdown]');
    if (counts.length) {
      var tick = function () {
        counts.forEach(function (el) {
          var target = new Date(el.getAttribute('data-countdown')).getTime();
          var diff = target - Date.now();
          if (isNaN(target)) return;
          if (diff <= 0) {
            el.textContent = el.getAttribute('data-live-label') || 'now live';
            return;
          }
          var d = Math.floor(diff / 864e5);
          var h = Math.floor((diff % 864e5) / 36e5);
          var m = Math.floor((diff % 36e5) / 6e4);
          var s = Math.floor((diff % 6e4) / 1e3);
          el.textContent = (d > 0 ? d + 'd ' : '') + h + 'h ' + m + 'm ' + s + 's';
        });
      };
      tick();
      setInterval(tick, 1000);
    }

    /* ---- rotation ---- */
    var msgs = Array.prototype.slice.call(bar.querySelectorAll('.cf-announce__msg'));
    if (msgs.length <= 1 || reduceMotion) return;

    var interval = parseInt(bar.getAttribute('data-rotate') || '4500', 10);
    var i = 0;
    var paused = false;
    var timer = setInterval(advance, interval);

    function advance() {
      if (paused) return;
      msgs[i].classList.remove('is-active');
      i = (i + 1) % msgs.length;
      msgs[i].classList.add('is-active');
    }

    bar.addEventListener('mouseenter', function () { paused = true; });
    bar.addEventListener('mouseleave', function () { paused = false; });
    bar.addEventListener('focusin', function () { paused = true; });
    bar.addEventListener('focusout', function () { paused = false; });
    document.addEventListener('visibilitychange', function () {
      paused = document.hidden;
    });
  }

  function boot() {
    document.querySelectorAll('.cf-announce').forEach(initBar);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
